import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelSearchDecryptionRequest,
  failSearchDecryption,
  setSearchDecryption,
  setSearchDecryptionFromApi,
  updateSearchDecryption,
  updateSearchDecryptionFromApi,
} from './search-decryption.actions';

/**
 * Service to handle async SearchDecryption actions
 */
@Injectable()
export class SearchDecryptionEffect {
  /**
   * Set the state with the reply content, dispatch failSearchDecryption if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setSearchDecryptionFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setSearchDecryption({ model: reply, requestId: action.requestId }),
        (error, action) => of(failSearchDecryption({ error, requestId: action.requestId })),
        cancelSearchDecryptionRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failSearchDecryption if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateSearchDecryptionFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateSearchDecryption({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failSearchDecryption({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
